import React, { useState } from 'react'
import { getRelativeBasePath } from '../../../global/environments/path.js'
import Loader from '../../../components/Loading/Loading.jsx'
import InstitutionalChangePassword from './common/InstitutionalChangePassword.jsx'
import { makeChangePasswordRequest } from './common/institutionalServiceHelper.js'

function InstitutionalChangePasswordContainter() {
  const [isShowLoader, setShowLoader] = useState(false)

  const onSuccessChangePassword = async (payload, handleError) => {
    setShowLoader(true)
    try {
      const data = await makeChangePasswordRequest(payload, {
        action: 'changePwd',
      })
      if (data && !data.error) {
        window.location.href =
          getRelativeBasePath() + '/secure/your-reports?changePassword=true'
      } else {
        if (data?.error?.details) {
          handleError(data.error.details.code, data.error.details.message)
        } else {
          handleError(data?.error?.code, data.error.message)
        }
      }
    } catch (error) {
      console.log(error)
    }
    setShowLoader(false)
  }

  return (
    <>
      <div className="u-bgColorBrandDark">
        <div className="u-sizeConstrained">
          <h1 className="u-textColorWhite  u-sm-textSizeMsrp4 u-md-textSizeMsrp5 u-paddingVert4gu">
            Change Password
          </h1>
        </div>
      </div>
      <div className="u-posRelative u-bgColorLightest u-borderColorNeutralLight u-borderBottom u-borderTop u-borderLeft0 u-borderRight0 u-padding8gu u-marginBottom10gu">
        {isShowLoader && <Loader />}
        <InstitutionalChangePassword {...{ onSuccessChangePassword }} />
      </div>
    </>
  )
}
export default InstitutionalChangePasswordContainter
